/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRadiationDosimetry from './treatment-radiation-dosimetry';
import TreatmentRadiationDosimetryDetail from './treatment-radiation-dosimetry-detail';
import TreatmentRadiationDosimetryUpdate from './treatment-radiation-dosimetry-update';
import TreatmentRadiationDosimetryDeleteDialog from './treatment-radiation-dosimetry-delete-dialog';

const TreatmentRadiationDosimetryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRadiationDosimetry />} />
    <Route path="new" element={<TreatmentRadiationDosimetryUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRadiationDosimetryDetail />} />
      <Route path="edit" element={<TreatmentRadiationDosimetryUpdate />} />
      <Route path="delete" element={<TreatmentRadiationDosimetryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRadiationDosimetryRoutes;
